import React, { forwardRef, useState, useEffect } from 'react';
interface InputProps {
    id: string;
    name: string;
    type: 'text' | 'email' | 'number';
    value?: string | number | readonly string[] | undefined;
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: any) => void;
    required?: boolean | undefined;
    onClick?: (e: any) => void;
    readonly?: boolean;
    className?: string;
    maxLength?: number;
    inputMode?: any;
    pattern?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            id,
            name,
            value,
            placeholder,
            type,
            onChange,
            onBlur,
            required,
            onClick,
            readonly,
            className = '',
            maxLength,
            inputMode,
            pattern,
        },
        ref,
    ) => {
        // 入力確認で.is-input付与。呼び出し側でもonchange使えるように
        const [hasInput, setHasInput] = useState(false);
        useEffect(() => {
            setHasInput(!!value && value !== '');
        }, [value]);
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (onChange) {
                onChange(e);
            }
            setHasInput(!!e.target.value);
        };

        return (
            <input
                id={id}
                name={name}
                type={type === 'number' ? 'text' : type}
                inputMode={type === 'number' ? 'numeric' : undefined}
                pattern={type === 'number' ? '[0-9]*' : undefined}
                value={value}
                placeholder={placeholder}
                onChange={handleChange}
                onClick={onClick}
                onBlur={onBlur}
                required={required}
                readOnly={readonly}
                ref={ref}
                maxLength={maxLength}
                className={`${className || ''} ${
                    hasInput ? 'is-input' : ''
                }`.trim()}
            />
        );
    },
);

export default Input;
